require('./brokerMyInvestmentsWrappedAssetsTable.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getPublicSiteUrl } = require('core/apiURLBuilder');
const { formatCurrency, formatWithoutRound } = require('utilities/currencyHelper');
const classNames = require('classnames');

// @actions
const BrokerMyInvestmentWidgetActions = require('actions/brokerMyInvestmentWidget');

// @constants
const {
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
} = require('constants/index');

// @constants
const { EURO_TEXT } = require('constants/index');

class BrokerMyInvestmentsWrappedAssetsTable extends React.Component {
    constructor(props) {
        super(props);

        this.buildAssetTitle = this.buildAssetTitle.bind(this);
        this.buildHeader = this.buildHeader.bind(this);
        this.handleContributionsSimulatorClick = this.handleContributionsSimulatorClick.bind(this);
        this.handleOpenTraderClick = this.handleOpenTraderClick.bind(this);
        this.handleOrdersAndMovementsClick = this.handleOrdersAndMovementsClick.bind(this);
        this.handleAcordionClick = this.handleAcordionClick.bind(this);
    }


    buildActualValueLabel() {
        const actualValue = formatWithoutRound(this.props.total, 2);
        const actualValueCurrency = formatCurrency(this.props.currency);
        const actualValueFormatted = `${actualValue} ${actualValueCurrency}`;

        return <span>{actualValueFormatted}</span>;
    }

    buildCapitalAmountLabel() {
        const { capital, earnings } = this.props;

        if (capital == null || earnings == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const investment = formatWithoutRound(capital, 2);
            const investmentCurrency = formatCurrency(this.props.currency);
            const investmentFormatted = `${investment} ${investmentCurrency}`;

            return <span>{investmentFormatted}</span>;
        }
    }

    buildEarningsAmountLabel() {
        const { capital, earnings, earningsPercentage } = this.props;

       if (capital == null || earnings == null) {
            return <FormattedText value="broker-myInvestmentsNotAvailableInitials" />;
        } else {
            const profitability = formatWithoutRound(earnings, 2);
            const profitabilityCurrency = formatCurrency(this.props.currency);
            const percentage = formatWithoutRound(earningsPercentage, 2);

            return this.buildProfitability(profitability, profitabilityCurrency, percentage);
        }
    }

    buildHeader() {
        const {
            itemsNumber,
            excludedItemsLabel,
            hasExcludedItems
        } = this.props;

        const capitalAmountLabel = this.buildCapitalAmountLabel();

        const earningsAmountLabel = this.buildEarningsAmountLabel();

        const totalAmount = this.buildActualValueLabel();

        let excludedItemsCounter;

        if (hasExcludedItems) {
            excludedItemsCounter = (
                <span className="broker-my-investments-wrap__excluded">
                    {excludedItemsLabel}
                </span>
            );
        }

        let statsBlock = (
            <React.Fragment>
                <span className="broker-assets-wrap__capital col-xs-4">
                    <span className="broker-assets-wrap__subtitle">
                        {formatText('broker-myInvestmentsProductsWrapInvestedCapitalLabel')}
                    </span>
                    <span className="broker-assets-wrap__capital-value">
                        {capitalAmountLabel}
                    </span>
                </span>
                <span className="broker-assets-wrap__earnings col-xs-4">
                    <span className="broker-assets-wrap__subtitle">
                        {formatText('broker-myInvestmentsProductsWrapEarningsLabel')}
                    </span>
                    <span className="broker-assets-wrap__earnings-value">
                        {earningsAmountLabel}
                    </span>
                </span>
                <span className="broker-assets-wrap__total col-xs-3">
                    <span className="broker-assets-wrap__subtitle">
                        {formatText('broker-myInvestmentsProductsWrapTotalAmountLabel')}
                    </span>
                    <span className="broker-assets-wrap__total-value">
                        {totalAmount}
                    </span>
                </span>
            </React.Fragment>
        );

        return (
            <div className="broker-my-investments-wrap__header">
                <div className="broker-assets-wrap__title col-xs-4">
                    <span className="broker-assets-wrap__type">
                        {this.buildAssetTitle()}
                    </span>
                    <span className="broker-my-investments-wrap__items-number">
                        ({itemsNumber}) {excludedItemsCounter}
                    </span>
                </div>
                <div className="broker-assets-wrap__balance col-xs-7 row">
                    {statsBlock}
                </div>
            </div>
        );
    }

    buildAssetTitle() {
        const { productType } = this.props;
        return (
            <span className="broker-assets-wrap__button-title">
                {productType}
            </span>
        )
    }

    buildProfitability(value, currency, percentage) {
        return (
            <div>
                <span className="broker-assets-wrap__earnings-value-currency">
                    <span className="broker-assets-wrap__earnings-value">{value}</span>
                    <span className="broker-assets-wrap__earnings-currency">{currency}</span>
                    <span className="broker-assets-wrap__earnings-separator">|</span>
                </span>
                <span className="broker-assets-wrap__earnings-percentage">{percentage}%</span>
            </div>
        )
    }

    handleContributionsSimulatorClick() {
        window.open(`${getPublicSiteUrl()}/simulador-de-aportaciones`, '_blank');
    }

    handleOpenTraderClick() {
        this.props.onOpenTraderClick();
    }

    handleOrdersAndMovementsClick(type) {
        this.props.setOrdersAndMovementsAccessFrom(type);
        this.props.history.push(MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL);
    }

    handleAcordionClick(type) {
        this.props.setAcordionExpandedValue(type);
    }

    render() {
        const { children, type, immBrokerMyInvestmentWidget } = this.props;
        const header = this.buildHeader();
        const waferIsExpanded = immBrokerMyInvestmentWidget.getIn(['waferIsExpanded', type]);
        const waferStyle = classNames('broker-assets-wrapper', {
            'broker-assets-not-expanded-wrapper': !waferIsExpanded
        });

        return (
            <div className={waferStyle}>
                <Accordion
                    id={`brokerProduct-${type}`}
                    isExpanded={waferIsExpanded}
                    onClick={() => this.handleAcordionClick(type)}
                    hasLargeContent={false}
                    customClassName={`broker-assets-wrap broker-assets-wrap--${type}`}
                >
                    <AccordionHeader name="AccordionHeader">
                        {header}
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        {children}
                    </AccordionBody>
                </Accordion>
            </div>
        );
    }
}

BrokerMyInvestmentsWrappedAssetsTable.defaultProps = {
    currency: EURO_TEXT
}

BrokerMyInvestmentsWrappedAssetsTable.propTypes = {
    children: PropTypes.any,
    productType: PropTypes.string,
    itemsNumber: PropTypes.number,
    excludedItemsLabel: PropTypes.string,
    hasExcludedItems: PropTypes.bool,
    earnings: PropTypes.number,
    earningsPercentage: PropTypes.number,
    total: PropTypes.number,
    capital: PropTypes.number,
    currency: PropTypes.string.isRequired,
    type: PropTypes.string,
    isContractSection: PropTypes.bool,
    onOpenTraderClick: PropTypes.func.isRequired,
    setOrdersAndMovementsAccessFrom: PropTypes.func.isRequired,
    setAcordionExpandedValue: PropTypes.func,
    immBrokerMyInvestmentWidget: PropTypes.object,
    history: PropTypes.object.isRequired,
};



module.exports.constructor = BrokerMyInvestmentsWrappedAssetsTable;
module.exports.BrokerMyInvestmentsWrappedAssetsTable = connect(
    state => ({
        immBrokerMyInvestmentWidget: state.brokerMyInvestmentWidget,
    }),
    {
        setAcordionExpandedValue: BrokerMyInvestmentWidgetActions.setAcordionExpandedValue
    }
)(withRouter(BrokerMyInvestmentsWrappedAssetsTable));
